import React from "react";
import {
  View,
  StyleSheet,
  TouchableOpacity,
} from "react-native";
import Icon from "react-native-vector-icons/FontAwesome";
import CustomText from "./CustomText";
import colors from "../constants/colors";

type NameData = {
  nombre: string;
  significado_resumido: string;
  significado_extendido: string;
  origen: string;
  personajes_famosos: string[];
  ranking: number;
  country: string;
  sex: "male" | "female";
};

interface SearchNameItemProps {
  name: NameData;
  isLiked: boolean;
  onLike: () => void;
  onPress: () => void;
}

const SearchNameItem: React.FC<SearchNameItemProps> = ({
  name,
  isLiked,
  onLike,
  onPress,
}) => {
  const getCountryFlag = (country: string): string => {
    const flags = {
      spain: "🇪🇸",
      eeuu: "🇺🇸",
      italy: "🇮🇹",
      sweden: "🇸🇪",
      uk: "🇬🇧",
    };
    return flags[country] || "🌍";
  };

  const getGenderSymbol = (sex: string): string => {
    return sex === "male" ? "♂" : "♀";
  };

  const backgroundColor =
    name.sex === "male" ? colors.maleBackground : colors.femaleBackground;

  return (
    <View style={[styles.container, { backgroundColor }]}>
      <TouchableOpacity style={styles.mainContent} onPress={onPress}>
        <View style={styles.nameHeader}>
          <CustomText style={styles.nameText}>
            {name.nombre} {getCountryFlag(name.country)} {getGenderSymbol(name.sex)}
          </CustomText>
        </View>
        <CustomText style={styles.meaningText} numberOfLines={2}>
          {name.significado_resumido}
        </CustomText>
      </TouchableOpacity>
      
      <View style={styles.actionsContainer}>
        <TouchableOpacity style={styles.likeButton} onPress={onLike}>
          <Icon 
            name={isLiked ? "heart" : "heart-o"} 
            size={20} 
            color={isLiked ? "#EC4899" : "#6B7280"} 
          />
        </TouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    marginBottom: 8,
    borderRadius: 12,
    paddingVertical: 12,
    paddingHorizontal: 16,
    alignItems: "center",
  },
  mainContent: {
    flex: 1,
    marginRight: 12,
  },
  nameHeader: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 4,
  },
  nameText: {
    fontSize: 18,
    fontFamily: "Urbanist_700Bold",
    color: colors.grayMedium,
    flex: 1,
  },
  meaningText: {
    fontSize: 14,
    fontFamily: "Urbanist_400Regular",
    color: colors.grayMedium,
    lineHeight: 20,
  },
  actionsContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
  likeButton: {
    padding: 8,
    borderRadius: 20,
    backgroundColor: "rgba(255, 255, 255, 0.8)",
  },
});

export default SearchNameItem;